import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info'; // Filled icon
import { Tooltip } from '@mui/material';

const BreadCrumb = ({ flow, faqsId }) => {
  const navigator = useNavigate()
  function cleanString(input) {
    return input?.replace(/\//g, '')?.replace(/\s+/g, '_')?.toLowerCase();;
  }
  return (
    <div className="pagetitle">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h1>{flow[0].label}</h1>
        {faqsId && <Tooltip onClick={() => {
          navigator("/faqs", { state: { id: faqsId } })
        }} title="Click here to view feature tutorial." sx={{ cursor: 'pointer' }}>
          <InfoIcon style={{ color: 'black', fontSize: 20, marginLeft: '20px' }} />
        </Tooltip>}
      </div>
      <nav>
        <ol className="breadcrumb">
          {
            flow?.map((item, index) => {
              if (index == 0) return;
              const active = index == flow?.length - 1;
              return (
                <li onClick={item.onClick} key={index} className={`breadcrumb-item ${active ? 'active' : ''}`}>
                  {active ? item.label : <Link to={item.to}>{item.label}</Link>}
                </li>
              )
            })
          }
        </ol>
      </nav>
    </div>
  )
}

export default BreadCrumb